import React, {Component} from "react"
import PropTypes from "prop-types"
import {NavLink as Link} from "react-router-dom"
import _sortBy from 'lodash/sortBy';
import "./MyStags.css"

const MyStagsItem = ({id, title, isAdmin}) => {
  return (
    <div className="MyStagsItem">
      <Link to={"/stag/" + id}>
        {isAdmin && ("ADMIN")}
        {title || "[ Title Not Set ]"}
      </Link>
    </div>
  );
};

class MyStags extends Component {
  render() {
    const {stags, fetching, createdStags} = this.props

    if (fetching && !Object.keys(stags).length) {
      return <div className="MyStags"> Loading My Stags... </div>
    }

    const joined = [], created = [];
    Object.keys(stags).forEach(stagId => {
      const stag = {
        ...stags[stagId],
        id: stagId,
      };
      if ( createdStags.indexOf(stagId) > -1 ) {
        created.push(stag);
      } else {
        joined.push(stag);
      }
    });

    return (
      <div className="MyStags">
        {created && created.length > 0 && (
          <div className="stag-list">
            <h5> CREATED STAGS </h5>
            {_sortBy(created, ["title"]).map(stag => <MyStagsItem key={stag.id} {...stag} />)}
          </div>
        )}
        {joined && joined.length > 0 && (
          <div className="stag-list">
            <h5> JOINED STAGS </h5>
            {_sortBy(joined, ["title"]).map(stag => <MyStagsItem key={stag.id} {...stag} />)}
          </div>
        )}
      </div>
    )
  }
}

MyStags.propTypes = {
  stags: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired,
  createdStags: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default MyStags



// WEBPACK FOOTER //
// ./src/component/organisms/MyStags/component.js